export const environment = {
    production: true,
    rootApiUrl: 'https://spring-dot-web-dot-escaperoommanagementapp.appspot.com',
    firebaseConfig: {
        apiKey: 'AIzaSyD6EHRwzHVmj1lnsz0dpmGJzXeyv8WsCeo',
        authDomain: 'escaperoommanagementapp.firebaseapp.com',
        databaseURL: 'https://escaperoommanagementapp.firebaseio.com',
        projectId: 'escaperoommanagementapp',
        storageBucket: 'escaperoommanagementapp.appspot.com',
        messagingSenderId: '302875917840',
        appId: '1:302875917840:web:abe54a8de72e7578c8d495',
        measurementId: 'G-QR10T1F3R4'
    }
};
